module.exports = {
  familyName: 'Cabin',
  capHeight: 1400,
  ascent: 1930,
  descent: -500,
  lineGap: 0,
  unitsPerEm: 2000
};